export default {
  BASE_URL: '',
  api: [
    {
      name: 'getProdCategories',
      method: 'GET',
      desc: '获取商品分类',
      path: '/category/product/category'
    },
    {
      name: 'getProdCategoriesHasRoot',
      method: 'GET',
      desc: '获取商品分类，存在根节点',
      path: '/category/backend/product/category'
    },
    {
      name: 'getAttributesForProd',
      method: 'GET',
      desc: '自营商城新增编辑详情获取商品属性',
      path: 'mm/attribute/getAttributesForProd'
    },
    {
      name: 'getBrands4EditProd',
      method: 'GET',
      desc: '自营商城新增编辑详情获取商品品牌',
      path: 'mm/brand/category',
      append: true
    },
    {
      name: 'getUnits4EditProd',
      method: 'GET',
      desc: '自营商城新增编辑详情获取计量单位',
      path: 'mm/unit/category',
      append: true
    },
    {
      name: 'getBrands4ProdList',
      method: 'POST',
      desc: '获取自营商城品牌列表',
      path: 'mm/brand/getBrandsForProd'
    },
    {
      name: 'cateLeaf',
      method: 'GET',
      desc: '获取分类（商品、招投标，平台）',
      path: 'category/leaf'
    },
    {
      name: 'cateChild',
      method: 'GET',
      desc: '获取分类-子分类（商品、招投标，平台）',
      path: 'category/child'
    },
    {
      name: 'cateStatus',
      method: 'POST',
      desc: '设置分类状态（商品、招投标，平台）',
      path: 'category/operate/status'
    },
    {
      name: 'cateOperate',
      method: 'POST',
      desc: '新增编辑分类（商品、招投标，平台）',
      path: 'category/operate'
    },
    {
      name: 'cateDetail',
      method: 'GET',
      desc: '获取标书详情（商品、招投标，平台）',
      path: 'category/currentCategoryInfo'
    },
    {
      name: 'cateModule',
      method: 'GET',
      desc: '获取分类的业务模块（商品、招投标，平台）',
      path: 'category/buss/module'
    },
    {
      name: 'searchOrgs',
      method: 'GET',
      desc: '根据关键词搜索客户名称',
      path: 'org/searchOrgs'
    },
    {
      name: 'searchProjs',
      method: 'GET',
      desc: '根据关键词搜索项目名称',
      path: 'crm/project/searchProjs'
    },
    {
      name: 'getPaymentConfig',
      method: 'GET',
      desc: '获取中台结算方式设置参数',
      path: 'pub/config/getPaymentConfig'
    },
    {
      name: 'getTenderType',
      method: 'GET',
      desc: '获取招标类型',
      path: '/category/buss/module',
      params: {
        head: true,
        all: false
      }
    },
    {
      name: 'dictList',
      method: 'GET',
      desc: '根据字典类型获取查询列表',
      path: 'pub/dict/list',
      append: true
    },
    {
      name: 'gtSend',
      method: 'POST',
      desc: '获取短信验证码',
      path: '/pub/sms/gtSend'
    },
    {
      name: 'startCaptcha',
      method: 'GET',
      desc: '极验验证初始化',
      path: '/pub/gt/startCaptcha'
    },
    {
      name: 'scan',
      desc: '识别身份证',
      method: 'GET',
      path: '/crmMember/ocr/IDCard'
    },
    {
      name: 'catagoryList',
      desc: '所属类型',
      method: 'GET',
      path: '/pub/inquiry/catagories'
    },
    {
      name: 'selectOnAreaLevel',
      desc: '获取地区地址(省)',
      method: 'GET',
      path: 'pub/area/china/selectOnAreaLevel/{areaLevel}'
    },
    {
      name: 'selectOnParentCode',
      desc: '获取地区地址(市)',
      method: 'GET',
      path: 'pub/area/china/selectOnParentCode/{parentCode}'
    },
    {
      name: 'getFinanceBusinessType',
      desc: '财务推送类型',
      method: 'GET',
      path: '/tm/order/getFinanceBusinessType'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/public.js